exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "[data-wps-guard] {\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  overflow: hidden; }\n\n[data-wps-guard=\"hidden\"] {\n  display: none; }\n\n[data-wps-href], [data-wps-popup-close-intent] {\n  cursor: pointer; }\n", ""]);

